var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('pt-active-sign-notes',{staticClass:"pt-active-sign-notes__page",attrs:{"name":_vm.name,"id":_vm.id}})}
var staticRenderFns = []

export { render, staticRenderFns }